import { Toggle, Loader, Input, Button } from '@driftt/tide-core-legacy'

import './style.styl'


export default ({
  hasConvoLimit,
  onToggleConvoLimit,
  convoLimitForUserLoading,
  convoLimitForUserNeverLoaded,
  localConvoLimit,
  onChangeConvoLimit,
  onSave,
  convoLimitForUserSavedSuccess,
}) => (
  <div>
    <label>Add a conversation limit to this user?</label>
    {(convoLimitForUserLoading || convoLimitForUserNeverLoaded) && <Loader className="user-individual-convo-limit-loader" />}
    {(!convoLimitForUserLoading && !convoLimitForUserNeverLoaded) &&
      <div>
        <Toggle checked={hasConvoLimit} onChange={onToggleConvoLimit} />
        {hasConvoLimit &&
          <Input type="number" value={localConvoLimit} onChange={onChangeConvoLimit} />
        }
        <Button type="primary" onClick={onSave}>Save</Button>
        {convoLimitForUserSavedSuccess && <div>Saved successfully!</div>}
      </div>
    }
  </div>
)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/team/IndividualConversationLimit/component.js